import { render, staticRenderFns } from "./ButtonPrimaryAccordion.vue?vue&type=template&id=8d1964d8&scoped=true"
import script from "./ButtonPrimaryAccordion.vue?vue&type=script&lang=js"
export * from "./ButtonPrimaryAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1964d8",
  null
  
)

export default component.exports